var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompressor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 15.5626V25.4197C5 29.0414 5 29.0414 8.33333 31.3477L17.5 36.7802C18.8833 37.6002 21.1333 37.6002 22.5 36.7802L31.6667 31.3477C35 29.0414 35 29.0414 35 25.4368V15.5626C35 11.9579 35 11.9579 31.6667 9.65167L22.5 4.21913C21.1333 3.39912 18.8833 3.39912 17.5 4.21913L8.33333 9.65167C5 11.9579 5 11.9579 5 15.5626Z",
    stroke: "#45494B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 25.6248C22.7614 25.6248 25 23.3303 25 20.4998C25 17.6693 22.7614 15.3748 20 15.3748C17.2386 15.3748 15 17.6693 15 20.4998C15 23.3303 17.2386 25.6248 20 25.6248Z",
    fill: "#3FC174",
    stroke: "#3FC174",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompressor);
export default __webpack_public_path__ + "static/media/compressor.3b5cbc15fc6eb9e7e68b392a52ad588a.svg";
export { ForwardRef as ReactComponent };